import { FeatureToggleClientService } from 'feature-toggle-client';
const DeskNewCustomReplies = 'new-custom-replies-blip-desk';
const DeskSalesforceIntegration = 'desk-salesforce-integration';
const UseDeskMicroFrontend = 'use-desk-micro-frontend';
const DeskWebhookIntegration = 'desk-webhook-provider';
const AgentPaginator = 'desk-agent-paginator';
const HideRulesAttendants = 'hide-rules-attendants';
const DirectTransfer = 'direct-ticket-transfer';
const TicketExportDownload = 'ticket-export-download';
const AssignAttendantInQueue = 'assign-attendant-in-queue';
const AllowSelectTimeZone = 'allow-select-time-zone';
const PriorityAttendanceQueueEnabled = 'priority-tickets-queue-attendance';
const TagsQueueEnabled = 'enable-tags-queue-attendance';
const isAttendancePermissionEnabled = 'attendance-permission';
const ReportMfeEnabled = 'desk-report-mfe';
const MonitoringMfeEnabled = 'desk-monitoring-mfe';
const ChannelsMfeEnabled = 'desk-channels-mfe';
const RepliesMfeEnabled = 'desk-replies-mfe';
const PhasedHistoryMfeEnabled = 'desk-phased-history-mfe';
const DeleteAttendantDelegationDisabled = 'delete-attendant-delegation-disabled';
const isFakeAtendanceCategoryEnabled = 'fake-atendance-category';
const GetThreadMessageMerged = 'enable-get-threadmessage-merged';
const useThreadsDomain = 'use-threads-domain-on-contact-history';
const GetTicketHistoryMerged = 'enable-get-tickethistory-merged';
const AttendantMfe = 'desk-attendant-mfe';
const QueueManagementMfe = 'desk-queue-management-mfe';
const ActiveMessageSettingsMfe = 'desk-active-message-settings-mfe';
const PaymentLinkPermission = 'desk-payment-link-permission';
const TransferAttendantPermission = 'ticket-transfer-attendant-permissions';
const AttendantCallsPermission = 'desk-attendant-calls-permission-and-config';
const AttendantVideoCallsPermission = 'desk-video-calls';
const AttendantReceiveCallsPermission = 'desk-receive-calls-permission-and-config';
const WidgetHelpCenter = 'widget-blip-chat-help-center';
const SalesDashboardFeature = 'desk-sales-deshboard';
const SurveyDashboard = 'attendance-survey-dashboard';
const LeadScoreFeature = 'desk-lead-score-config';
const ContactHistory = 'enable-contact-history';
const CallsDashboardFeature = 'blip-calls-dashboard';
const ConfigurationsApplicationsDomainUsageGet = 'use-configurations-domain-on-attendance-operations-get';
const ConfigurationsApplicationsDomainUsageSet = 'use-configurations-domain-on-attendance-operations-set';
const SLAPolicyMfeEnabled = 'desk-sla-policy-mfe';
const MetadataManagementFeatureEnabled = 'desk-metadata-management';
const DeskQualityAssuranceEnabled = 'desk-qa-enabled';
const AttendanceMenuMfeEnabled = 'attendance-menu-mfe';
const AttendancePermissionsGranularityEnabled = 'attendance-permissions-granularity';
export class AttendanceFeatures {
    static isDeskNewCustomRepliesEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(DeskNewCustomReplies);
    }
    static isDeskSalesforceIntegrationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(DeskSalesforceIntegration);
    }
    static isUseDeskMicroFrontendEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(UseDeskMicroFrontend);
    }
    static isDeskWebhookIntegrationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(DeskWebhookIntegration);
    }
    static isAgentPaginatorEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AgentPaginator);
    }
    static isHideRulesAttendantsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(HideRulesAttendants);
    }
    static isDirectTransferEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(DirectTransfer);
    }
    static isTicketExportDownloadEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(TicketExportDownload, false);
    }
    static isAssignAttendantInQueue() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AssignAttendantInQueue, false);
    }
    static isAllowSelectTimeZone() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(AllowSelectTimeZone);
    }
    static isPriorityAttendanceQueueEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(PriorityAttendanceQueueEnabled);
    }
    static isTagsQueueEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(TagsQueueEnabled, false);
    }
    static isAttendantMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AttendantMfe, false);
    }
    static isQueueManagementMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(QueueManagementMfe, false);
    }
    static isReportMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ReportMfeEnabled, false);
    }
    static isMonitoringMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(MonitoringMfeEnabled, false);
    }
    static isChannelsMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ChannelsMfeEnabled, false);
    }
    static isRepliesMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(RepliesMfeEnabled, false);
    }
    static phasedHistoryMfeFT() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(PhasedHistoryMfeEnabled, false);
    }
    static isAttendancePermissionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isAttendancePermissionEnabled);
    }
    static isDeleteAttendantDelegationDisabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(DeleteAttendantDelegationDisabled, false);
    }
    static isFakeAtendanceProfileEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isFakeAtendanceCategoryEnabled, false);
    }
    static isGetThreadMessageMergedEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(GetThreadMessageMerged, false);
    }
    static isThreadsDomainEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(useThreadsDomain, false);
    }
    static isGetTicketHistoryMergedEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(GetTicketHistoryMerged, false);
    }
    static isActiveMessageSettingsMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ActiveMessageSettingsMfe, false);
    }
    static isPaymentLinkPermissionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(PaymentLinkPermission, false);
    }
    static isTransferAttendantPermissionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(TransferAttendantPermission, false);
    }
    static isAttendantCallsPermissionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AttendantCallsPermission, false);
    }
    static isAttendantVideoCallsPermissionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AttendantVideoCallsPermission, false);
    }
    static isAttendantReceiveCallsPermissionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AttendantReceiveCallsPermission, false);
    }
    static isWidgetBlipChatHelpCenterEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(WidgetHelpCenter, false);
    }
    static isSalesDashboardEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(SalesDashboardFeature, false);
    }
    static isSurveyDashboardEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(SurveyDashboard, false);
    }
    static isLeadScoreFeature() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(LeadScoreFeature, false);
    }
    static isContactHistoryFeatureEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ContactHistory, false);
    }
    static isCallsDashboardEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(CallsDashboardFeature, false);
    }
    static isUseConfigurationsDomainOnAttendanceOperationsGetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ConfigurationsApplicationsDomainUsageGet, false);
    }
    static isUseConfigurationsDomainOnAttendanceOperationsSetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ConfigurationsApplicationsDomainUsageSet, false);
    }
    static isSLAPolicyMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(SLAPolicyMfeEnabled, false);
    }
    static isMetadataManagementEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(MetadataManagementFeatureEnabled, false);
    }
    static isDeskQAEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(DeskQualityAssuranceEnabled, false);
    }
    static isAttendanceMenuMfeEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AttendanceMenuMfeEnabled, false);
    }
    static isAttendancePermissionsGranularityEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AttendancePermissionsGranularityEnabled, false);
    }
}
